import ConfigurableTable from "@/components/lists/configurable-table";
import { fields } from "@/lib/compensations/fields";
import { useReadItems } from "@/lib/compensations/read";

export default function ArchivedCompensations() {
  const { data } = useReadItems();

  return <ConfigurableTable data={data ?? []} fields={fields} />;
}
